import { createQueryKeys, type Query } from '@shared/api';

/**
 * Ключи запросов гаража.
 *
 * Семейства разведены по вкладкам, а не по «списку и сводке»: у техники и водителей свои фильтры,
 * и общий ключ гасил бы соседнюю вкладку при каждой смене фильтра на текущей. День среза приходит
 * внутри параметров — по нему TanStack Query и различает запросы, поэтому переключение даты
 * показывает уже загруженный день мгновенно, а незагруженный тянет один раз.
 *
 * **Почему `garageKeys.root` гасят чужие экраны.** Своих таблиц у гаража нет: день собирается
 * сервером из техники, водителей с их удостоверениями, рейсов, путевых листов и заказов
 * спецтехники (`services/garage.ts`). Значит кэш среза устаревает от правок, которые собственных
 * данных гаража не трогают вовсе, — машину увели в ремонт, завели рейс, выписали лист, назначили
 * технику на заявку, — а гасят эти мутации свои корни (`['vehicles']`, `['vehicle-routes']`,
 * `['waybills']`, `['vehicle-requests']`), до `['garage']` не достающие. Поэтому каждое такое
 * место гасит корень гаража рядом со своим; ждать `staleTime` нельзя — вернувшийся по «назад»
 * диспетчер увидит машину свободной, когда она уже занята. Обратной зависимости нет: раздел
 * читающий, мутаций у него не бывает (ADR 0076).
 */
export const garageKeys = createQueryKeys('garage', {
  vehicles: (params: Query) => ['vehicles', params],
  vehiclesSummary: (params: Query) => ['vehicles-summary', params],
  drivers: (params: Query) => ['drivers', params],
  driversSummary: (params: Query) => ['drivers-summary', params],
  driverSchedule: (personId: string, params: Query) => ['driver-schedule', personId, params],
});
